<script>
    import Region from './Region.svelte';
    import Info from './Info.svelte';
    import Tile from './Tile.svelte';
    import {createEventDispatcher} from 'svelte';
    import './Order.css';

    const dispatch = createEventDispatcher();

    export let contractId = '';
    export let name = '';
    //export let openDate = ''; //
    export let date = '';
    export let time = '';
    export let id;
    let regions = [];
    let expanded = false;
    let loaded = false;
    
    const toggle = () => {
        console.log('toggle_fetch'); //
        if (!loaded && !expanded) {
            fetch(`api/Regions/ByOrder/${id}`)
            .then(response => response.json())
            .then(json => {
                loaded = true;
                regions = json;
            })
            .catch(e => console.log(e));
        }
        //console.log(detail);
        expanded = !expanded;
    };

    const process = (detail) => {
        //let regionData = {'customerId':regions[0].order.customerId, 'orderId':regions[0].orderId, 'roiId':regions[0].id};
        let regionData = {'Client':regions[0].order.customerId, 'Order':regions[0].orderId, 'ROI':regions[0].id};
        detail.regionData = regionData;
        console.log('process_res_new', detail);
        fetch(`http://192.168.4.177:5002/sip/batch`, {
			//mode:'no-cors',
			method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(detail)
        })
            .then(response => response.json())
            .then(json => {
                console.log(json);
            })
    }

    let headerContainer;
    let info;
    let tile;

    const select = ({detail}) => {
        console.log(detail)
        //const {sceneId, tileName,  reset} = detail;
        //const {tileName, sceneId, productType,  date, time, product: {platform, name, }, reset} = detail;
        const {tileName,  reset} = detail;
        
        if (tileName === undefined) {
            console.log('grn')
            const {sceneId, productType,  date, time, product: {platform, name, }, reset} = detail;
            if (!info) {
            info = new Info({
                target: document.body,
                props: {sceneId, productType, date, time, platform, name}
            });
            console.log(info);
            const {top, left, width} = headerContainer.getBoundingClientRect();
            info.adjustPosition({top, left: left + width + 20});
            info.$on('close', () => {
                info.$destroy();
                info = null;
                reset();
            });
            if (tile != undefined) {
                tile.$destroy();
                tile = null;
                reset();
            }
        }
        else {
            info.$set({sceneId, productType, date, time, platform, name});
        }
        return;
        }
        
        if (!tile /*&& tileName != undefined*/) {
            //const {tileName,  reset} = detail;
            console.log('tile')
            tile = new Tile({
                target: document.body,
                props: {tileName }
            });
            const {top, left, width} = headerContainer.getBoundingClientRect();
            tile.adjustPosition({top, left: left + width + 20});
            tile.$on('process', (e) => {
                console.log('detail_0', e.detail.values);
                process(e.detail);
            });
            if (info != undefined) {
                info.$destroy();
                info = null;
                reset();
            }
            tile.$on('close', () => {
                tile.$destroy();
                tile = null;
                reset();
            });
        }
        else {
            tile.$set({tileName});
        }
    }; 

</script>

<div class="order">
    <div class="header" on:click|stopPropagation="{toggle}" bind:this="{headerContainer}">
        <i class="icon" class:caret-right="{!expanded}" class:caret-down="{expanded}"></i>
        <span>{contractId || name || date }</span>
    </div>
    <div class="content" class:hidden="{!expanded}">
        {#each regions as r}
        <Region {...r}
            on:select="{select}"
            on:selection="{({detail}) => dispatch('selection', detail)}"
            on:download="{() => dispatch('download')}"
            on:preview="{({detail}) => dispatch('preview', detail)}"
            on:expand="{({detail}) => dispatch('expand', detail)}" />
        {/each}
    </div>
</div>
